export const DATA_AUTOMATION_INITIATE = 'src/Analyst/Cases/View/action/Data_Automation_Initiate'
export const DATA_AUTOMATION_INITIATE_SUCCESS = 'src/Analyst/Cases/View/action/Data_Automation_Initiate_Success'
export const DATA_AUTOMATION_INITIATE_FAILURE = 'src/Analyst/Cases/View/action/Data_Automation_Initiate_Failure'

export const dataAtuomationInitiate = (data) => {
    return {
        type: DATA_AUTOMATION_INITIATE,
        data
    }
}
export const dataAtuomationInitiateSuccess = (data) => {
    return {
        type: DATA_AUTOMATION_INITIATE_SUCCESS,
        data
    }
}
export const dataAtuomationInitiateFailure = (data) => {
    return {
        type: DATA_AUTOMATION_INITIATE_FAILURE,
        data
    }
}

export const GET_CRAWLER_STATUS = 'src/Analyst/Cases/View/action/Get_Crawler_Status';
export const GET_CRAWLER_STATUS_SUCCESS = 'src/Analyst/Cases/View/action/Get_Crawler_Status_Success';
export const GET_CRAWLER_STATUS_FAILURE = 'src/Analyst/Cases/View/action/Get_Crawler_Status_Failure';

export const getCrawlerStatus = (data) => {
    return {
        type: GET_CRAWLER_STATUS,
        data
    }
}
export const getCrawlerStatusSuccess = (data) => {
    return {
        type: GET_CRAWLER_STATUS_SUCCESS,
        data
    }
}
export const getCrawlerStatusFailure = (data) => {
    return {
        type: GET_CRAWLER_STATUS_FAILURE,
        data
    }
}

export const GET_CRAWLER_MARKASFAIL = 'src/Analyst/Cases/View/action/Get_Crawler_Markasfail';
export const GET_CRAWLER_MARKASFAIL_SUCCESS = 'src/Analyst/Cases/View/action/Get_Crawler_Markasfail_Success';
export const GET_CRAWLER_MARKASFAIL_FAILURE = 'src/Analyst/Cases/View/action/Get_Crawler_Markasfail_Failure';

export const getCrawlerMarkasfail = (data) => {
    return {
        type: GET_CRAWLER_MARKASFAIL,
        data
    }
}
export const getCrawlerMarkasfailSuccess = (data) => {
    return {
        type: GET_CRAWLER_MARKASFAIL_SUCCESS,
        data
    }
}
export const getCrawlerMarkasfailFailure = (data) => {
    return {
        type: GET_CRAWLER_MARKASFAIL_FAILURE,
        data
    }
}


export const INTITIATE_LEGAL_CRAWLER  = "INTITIATE_LEGAL_CRAWLER";
export const LEGAL_CRAWLER_RESPONSE = "LEGAL_CRAWLER_RESPONSE";

export const initiateLegalCrawler = (data) => {
    return {
        type: INTITIATE_LEGAL_CRAWLER,
        data
    }
}

export const legalCrawlerResponse = (data) => {
    return {
        type: LEGAL_CRAWLER_RESPONSE,
        data
    }
}

export const LEGAL_SETCION_TEMPLATES_REQUEST = "LEGAL_SETCION_TEMPLATES_REQUEST";
export const LEGAL_SETCION_TEMPLATES_RESPONSE = "LEGAL_SETCION_TEMPLATES_RESPONSE";


export const legalSectionTemplateRequest = (data) => {
    return {
        type : LEGAL_SETCION_TEMPLATES_REQUEST,
        data
    }
}

export const legalSectionTemplateResponse = (data) => {
    return {
        type : LEGAL_SETCION_TEMPLATES_RESPONSE,
        data
    }
}

export const NIC_SEARCH_REQUEST = "NIC_SEARCH_REQUEST";
export const NIC_SEARCH_RESPONSE = "NIC_SEARCH_RESPONSE";


export const nicSearchRequest = (data) => {
    return {
        type : NIC_SEARCH_REQUEST,
        data
    }
}

export const nicSearchResponse = (data) => {
    return {
        type : NIC_SEARCH_RESPONSE,
        data
    }
}

export const ZIGRAM_SEARCH_RESPONSE = "ZIGRAM_SEARCH_RESPONSE";
export const INTITIATE_ZIGRAM_CRAWLER  = "INTITIATE_ZIGRAM_CRAWLER";

export const initiateZigramRequest = (data) => {
    return {
        type: INTITIATE_ZIGRAM_CRAWLER,
        data
    }
}

export const zigramSearchResponse = (data) => {
    return {
        type : ZIGRAM_SEARCH_RESPONSE,
        data
    }
}

export const ZIGRAM_EXCEL_RESPONSE = "ZIGRAM_EXCEL_RESPONSE";
export const INTITIATE_ZIGRAM_EXCEL_REQUEST  = "INTITIATE_ZIGRAM_EXCEL_REQUEST";

export const initiateZigramExcelRequest = (data) => {
    return {
        type: INTITIATE_ZIGRAM_EXCEL_REQUEST,
        data
    }
}

export const zigramExcelResponse = (data) => {
    return {
        type : ZIGRAM_EXCEL_RESPONSE,
        data
    }
}


export const KYC_DATA_AUTOMATION_INITIATE = 'src/Analyst/Cases/View/action/Kyc_Data_Automation_Initiate'
export const KYC_DATA_AUTOMATION_INITIATE_SUCCESS = 'src/Analyst/Cases/View/action/Kyc_Data_Automation_Initiate_Success'
export const KYC_DATA_AUTOMATION_INITIATE_FAILURE = 'src/Analyst/Cases/View/action/Kyc_Data_Automation_Initiate_Failure'

export const kycDataAtuomationInitiate = (data) => {
    return {
        type: KYC_DATA_AUTOMATION_INITIATE,
        data
    }
}
export const kycDataAtuomationInitiateSuccess = (data) => {
    return {
        type: KYC_DATA_AUTOMATION_INITIATE_SUCCESS,
        data
    }
}
export const kycDataAtuomationInitiateFailure = (data) => {
    return {
        type: KYC_DATA_AUTOMATION_INITIATE_FAILURE,
        data
    }
}


export const GET_KYC_CRAWLER_STATUS = 'src/Analyst/Cases/View/action/Get_Kyc_Crawler_Status';
export const GET_KYC_CRAWLER_STATUS_SUCCESS = 'src/Analyst/Cases/View/action/Get_Kyc_Crawler_Status_Success';
export const GET_KYC_CRAWLER_STATUS_FAILURE = 'src/Analyst/Cases/View/action/Get_Kyc_Crawler_Status_Failure';

export const getKycCrawlerStatus = (data) => {
    return {
        type: GET_KYC_CRAWLER_STATUS,
        data
    }
}
export const getKycCrawlerStatusSuccess = (data) => {
    return {
        type: GET_KYC_CRAWLER_STATUS_SUCCESS,
        data
    }
}
export const getKycCrawlerStatusFailure = (data) => {
    return {
        type: GET_KYC_CRAWLER_STATUS_FAILURE,
        data
    }
}

export const ADDITIONAL_LEGAL_TEMPLATE_REQUEST = 'ADDITIONAL_LEGAL_TEMPLATE_REQUEST';
export const ADDITIONAL_LEGAL_TEMPLATE_RESPONSE = 'ADDITIONAL_LEGAL_TEMPLATE_RESPONSE';

export const additionalLegalTemplateRequest = () => {
    return {
        type: ADDITIONAL_LEGAL_TEMPLATE_REQUEST,
    }
}
export const additionalLegalTemplateResponse = (data) => {
    return {
        type: ADDITIONAL_LEGAL_TEMPLATE_RESPONSE,
        data
    }
}

export const ADDITIONAL_LEGAL_UPLOAD_REQUEST = 'ADDITIONAL_LEGAL_UPLOAD_REQUEST';
export const ADDITIONAL_LEGAL_UPLOAD_RESPONSE = 'ADDITIONAL_LEGAL_UPLOAD_RESPONSE';

export const additionalLegalUploadRequest = (data) => {
    return {
        type: ADDITIONAL_LEGAL_UPLOAD_REQUEST,
        data
    }
}
export const additionalLegalUploadResponse = (data) => {
    return {
        type: ADDITIONAL_LEGAL_UPLOAD_RESPONSE,
        data
    }
}

export const AML_PEP_TEMPLATE_REQUEST = 'AML_PEP_TEMPLATE_REQUEST';
export const AML_PEP_TEMPLATE_RESPONSE = 'AML_PEP_TEMPLATE_RESPONSE';

export const amlPepTemplateRequest = () => {
    return {
        type: AML_PEP_TEMPLATE_REQUEST,
    }
}
export const amlPepTemplateResponse = (data) => {
    return {
        type: AML_PEP_TEMPLATE_RESPONSE,
        data
    }
}

// Add these action types
export const INITIATE_MASTER_DATA_SYNC = "INITIATE_MASTER_DATA_SYNC";
export const MASTER_DATA_SYNC_RESPONSE = "MASTER_DATA_SYNC_RESPONSE";

// Add these action creators
export const initiateMasterDataSync = (data) => ({
    type: INITIATE_MASTER_DATA_SYNC,
    data
});

export const masterDataSyncResponse = (data) => ({
    type: MASTER_DATA_SYNC_RESPONSE,
    data: data
});

export const ITR_ANALYSIS_RESYNC = "ITR_ANALYSIS_RESYNC";
export const ITR_ANALYSIS_RESYNC_RESPONSE = "ITR_ANALYSIS_RESYNC_RESPONSE";

export const resyncItrAnalysis = (data) => ({
    type: ITR_ANALYSIS_RESYNC,
    data
});

export const itrAnalysisResyncResponse = (data) => ({
    type: ITR_ANALYSIS_RESYNC_RESPONSE,
    data
});